export const validateForm = (form, images, showLcdaField, categoryType = null) => {
    const errors = {};
  
    // Basic validation
    if (!form.title?.trim()) {
      errors.title = 'Title is required';
    } else if (form.title.trim().length < 3) {
      errors.title = 'Title must be at least 3 characters';
    }
  
    if (!form.price || isNaN(parseFloat(form.price)) || parseFloat(form.price) <= 0) {
      errors.price = 'Valid price is required';
    }
  
    if (!form.category_id) {
      errors.category = 'Category is required';
    }
  
    if (!form.state_id || !form.lga_id) {
      errors.location = 'Please select your state and LGA';
    }
  
    if (showLcdaField && !form.lcda_id) {
      errors.location = 'Please select your complete location';
    }
  
    if (images.length === 0) {
      errors.images = 'At least one image is recommended';
    }
  
    // Specialized validation based on category type
    if (categoryType === 'electronics') {
      if (!form.brand?.trim()) errors.brand = 'Brand is required';
      if (!form.model?.trim()) errors.model = 'Model is required';
    } else if (categoryType === 'services') {
      if (!form.experience_years || isNaN(parseInt(form.experience_years)) || parseInt(form.experience_years) < 0) {
        errors.experience_years = 'Valid years of experience is required';
      }
    } else if (categoryType === 'vehicles') {
      if (!form.make?.trim()) errors.make = 'Make is required';
      if (!form.model?.trim()) errors.model = 'Model is required';
      if (!form.year || isNaN(parseInt(form.year)) || parseInt(form.year) < 1900 || parseInt(form.year) > new Date().getFullYear() + 1) {
        errors.year = 'Valid year is required';
      }
      if (!form.color?.trim()) errors.color = 'Color is required';
    } else if (categoryType === 'properties') {
      if (!form.property_type) {
        errors.property_type = 'Property type is required';
      }
    }
  
    return errors;
  };